import React from "react";
import "./Footer.css";
import {
  email,
  facebook,
  insta,
  logo,
  maps,
  playstore,
  tiktok,
  whatsappImg,
  youtube,
} from "../../assets/imagesPath";
import { FaPhone } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import PATHS from "../../routes/Paths";

import { useGetContactSettingsQuery } from "../../services/Api";

const Footer = () => {
  const navigator = useNavigate();
  const { data: settingsData } = useGetContactSettingsQuery();
  const settings = settingsData?.status ? settingsData.data : {
    whatsapp_number: '+923000828456',
    phone_number: '+923000828456',
    email_address: 'easyqist@gmail.com'
  };

  const openGoogleMaps = () => {
    window.open('https://maps.app.goo.gl/BDRaTRQXVsqYWkQv7', '_blank');
  };

  return (
    <>
      <div className="footer">
        <div className="row">
          {/* Logo and Contact Section */}
          <div className="col-md-4">
            <img
              src={logo}
              className="cursor brand-logo"
              onClick={() => navigator(PATHS.home)}
              alt="Brand Logo"
            />

            <div className="mt-5">
              <p className="contactUstext">Contact Us</p>

              <div className="footer-contact-item">
                <img src={whatsappImg} className="me-3 callImg" alt="WhatsApp" />
                <p className="footertextColor">
                  Whats App <br />
                  {settings.whatsapp_number}
                </p>
              </div>

              <div className="footer-contact-item">
                <FaPhone className="me-3 callImg" style={{ color: '#2ECC40' }} aria-label="Phone" />
                <p className="footertextColor">
                  Call Us <br />
                  {settings.phone_number}
                </p>
              </div>

              {settings.email_address && (
                <div className="footer-contact-item">
                  <img
                    src={email}
                    className="me-3 callImg green"
                    style={{ height: 25, width: 20 }}
                    alt="Email"
                  />
                  <p className="footertextColor">
                    Email <br />
                    {settings.email_address}
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Customer Services Section */}
          <div className="col-md-4">
            <p className="footerHeading">
              <span>
                Customer <hr />
              </span>{" "}
              Services
            </p>

            <ul className="footerLinks">
              <li>
                <Link to={PATHS.termsAndConditions}>Terms & Conditions</Link>
              </li>
              <li>
                <Link to={PATHS.refundPolicy}>Return and Refund Policy</Link>
              </li>
              <li>
                <Link to={PATHS.privacyPolicy}>Privacy Policy</Link>
              </li>
              <li>
                <Link to={PATHS.faqs}>FAQs</Link>
              </li>
            </ul>

            <div className="map-container mt-4">
              <img
                src={maps}
                alt="Location Map"
                height={180}
                className="w-100 cursor"
                onClick={openGoogleMaps}
              />
            </div>
          </div>

          {/* Download App Section */}
          <div className="col-md-4 download-app-section">
            <p className="footerHeading">Download App:</p>

            <div className="d-flex flex-column align-items-start gap-4 mt-4">
              <a
                href="https://play.google.com/store/apps/details?id=com.easy.qist"
                target="_blank"
                rel="noopener noreferrer"
                className="app-store-link"
              >
                <img src={playstore} className="w-50" alt="Google Play Store" />
              </a>

              <div className="gap-4 d-flex align-items-center mt-4">
                <a
                  href="https://tiktok.com/@easyqist.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <img src={tiktok} height={37} alt="TikTok" />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61565595124134&mibextid=ZbWKwL"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <img src={facebook} height={30} alt="Facebook" />
                </a>
                <a
                  href="https://www.instagram.com/easyqist?igsh=MXhpeno3MHFuc3Vocw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <img src={insta} height={30} alt="Instagram" />
                </a>
                <a
                  href="https://youtube.com/@easyqist?si=mG20u07I9ojyKFtK"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <img src={youtube} height={30} alt="YouTube" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;